import { Component, Vue, Mixins, Watch } from 'vue-property-decorator';
import { AllComponents } from '@/components/AllComponents';
import CommonView from '@/views/CommonView';
import BASEAPI from '@/util/BASEAPI';
import { AxiosErrorHandler, isAxiosError } from '@/util/AxiosErrorHandler';
import { Redirect, RedirectPaymentMethodEnum } from '@/generated/api';
import { AxiosResponse } from 'axios';
import { creditEdit } from '@/util/Form';

@Component({
    components: AllComponents(),
})
export default class Shopping extends Mixins(CommonView) {
    kurukuru: boolean = false;
    public error: string = "";

    public product: BASEAPI.Product | null = null;
    public user: BASEAPI.User | null = null;

    public inSale: boolean = false;
    public now: number = 0;
    public startAt: number = 0;
    public endAt: number = 0;
    public amount: number = 1;
    public shipFee: number = 0;
    public preTaxShipFee: number = 0;
    public totalPrice: number = 0;
    public userProductShip: BASEAPI.UserProductShip | null = null;
    public paymentMethod: RedirectPaymentMethodEnum = RedirectPaymentMethodEnum.CARD;
    public agree: boolean = false;

    isNGPAYPAY: boolean = false; // PAYPAY決済停止(メンテ用)

    redirect: AxiosResponse<Redirect> | null = null;

    public async created() {
        await this.init();

    }

    @Watch('$route')
    public async init() {
        this.kurukuru = true;

        if (await this.isLoginRedirect(true)) return;

        let resUser = await BASEAPI.UserController.getUserUsingGET().catch(AxiosErrorHandler);
        if (isAxiosError(resUser)) {
            this.error = "" + resUser.data;
            this.$router.push("/");
            return;
        }
        this.user = resUser.data;

        let directoryName = this.$route.params.directoryName;
        if(!directoryName){
            this.$router.push("/");
            return;
        }

        let res = await BASEAPI.ProductController.getProductUsingGET(directoryName).catch(AxiosErrorHandler);
        if (isAxiosError(res)) {
            this.error = "" + res.data;
            this.$router.push("/");
            return;
        }
        this.product = res.data;

        // 販売チェック
        this.inSale = true;
        this.now = new Date().getTime();
        this.startAt = new Date(this.product.saleStartedAt!).getTime();
        this.endAt = new Date(this.product.saleEndedAt!).getTime();

        if(this.product.inSale === false){
            this.inSale = false;
        }

        if(this.startAt > this.now){
            this.inSale = false;
        }

        if(this.endAt < this.now){
            this.inSale = false;
        }

        if(!this.inSale){
            this.$router.push("/product/" + this.product.directoryName);
            return;
        }

        let resUserProductShip = await BASEAPI.UserProductShipController.getUserProductShipUsingGET(this.product!.id!).catch(AxiosErrorHandler);
        if (!isAxiosError(resUserProductShip)) {
            this.userProductShip = resUserProductShip.data;
        }

        this.changeTotalPrice();
        this.kurukuru = false;

        // PAYPAYメンテナンス対応 ------->
        this.isNGPAYPAY = false;
        const startTime = new Date(2022, 8, 12, 2, 0, 0).getTime(); // 停止時間
        const endTime = new Date(2022, 8, 12, 4, 0, 0).getTime(); // 終了時間
        const jstNow = new Date(Date.now() + ((new Date().getTimezoneOffset() + (9 * 60)) * 60 * 1000)).getTime(); // 現在時間
        if(startTime < jstNow && jstNow < endTime){
            this.isNGPAYPAY = true;
        }
        // <---------------------------
    }

    public changeTotalPrice(){
        this.amount = Number(this.amount);

        if(!this.userProductShip || (this.userProductShip.totalAmount + this.amount > 50)){
            if (this.amount === 100) {
                this.shipFee = this.product!.shipFee * 2;
                this.preTaxShipFee = this.product!.preTaxShipFee * 2;
            } else {
                this.shipFee = this.product!.shipFee;
                this.preTaxShipFee = this.product!.preTaxShipFee;
            }
        } else {
            this.shipFee = 0;
            this.preTaxShipFee = 0;
        }

        this.totalPrice = this.product!.price * this.amount + this.shipFee;
    }

    public async confirm(){
        this.kurukuru = true;
        this.error = "";

        if (this.getByteLength1() > 32) {
            this.error = "「住所」は32文字（半角32文字・全角16文字）以内で入力してください。";
            this.kurukuru = false;
            return;
        }

        if(!this.agree){
            this.error = "利用規約に同意してください。";
            this.kurukuru = false;
            return;
        }

        this.redirect = null;
        const url = "/product/" + this.product!.directoryName + "/result";
        let redirectRes = await BASEAPI.RedirectController.addRedirectUsingPOST(
            {
                amount: this.amount,
                paymentMethod: this.paymentMethod,
                productId: this.product!.id,
                url: url
            }).catch(AxiosErrorHandler);
        if (isAxiosError(redirectRes)) {
            this.error = "" + redirectRes.data;
            this.kurukuru = false;
            return;
        }

        this.redirect = redirectRes;
        this.pay();
    }

    public async pay(){
        if(!this.redirect) {
            this.kurukuru = false;
            return;
        }

        try {
            let res = await creditEdit("/api/credit/callBack?id=" + this.redirect.data.id, "/product/" + this.product!.directoryName +"/shopping", this.redirect.data.id!, "");
        } catch (error) {
            this.error = "" + error;
            this.kurukuru = false;
            return;
        }

        this.kurukuru = true;;
    }

    // バイト数を取得する関数
    public getByteLength1() {
        let count = 0;
        for (let i = 0; i < this.user!.address.length; i++) {
            const charCode = this.user!.address.charCodeAt(i);
            if (charCode <= 255) {
                count += 1; // 半角文字は1バイト
            } else {
                count += 2; // 全角文字は2バイト
            }
        }
        return count;
    }

    // バイト数を取得する関数
    public getByteLength2() {
        let count = 0;
        for (let i = 0; i < this.user!.address2.length; i++) {
            const charCode = this.user!.address2.charCodeAt(i);
            if (charCode <= 255) {
                count += 1; // 半角文字は1バイト
            } else {
                count += 2; // 全角文字は2バイト
            }
        }
        return count;
    }
}
